import { compose, lifecycle } from 'recompose'
import { parse } from 'query-string'

import config from 'config'

import LoadingPage from 'layouts/LoadingPage'

export default compose(
  lifecycle({
    componentDidMount() {
      const { webstore_access_type } = parse(window.location.search)

      if (webstore_access_type) {
        window.localStorage.setItem('drift_video_webstore_referrer', webstore_access_type)
      }
      
      window.location.replace(config.DRIFT_VIDEO_EXTENSION_URL)
    },
  }),
)(LoadingPage)



// WEBPACK FOOTER //
// ./src/layouts/TrackWebstoreReferrer/index.js